// Import js-cookie
import Cookies from 'js-cookie'

// Render content of interest
function renderContentOfInterest() {

    var category = Cookies.get('proell_category_of_interest');
    var categoryClass = '.' + category;

    var application = Cookies.get('proell_application_of_interest');
    var applicationClass = '.' + application;

    // Set category based content elements
    if (category && $(categoryClass).length) {
        // Set active category button
        $('.category-select').prop('disabled', false).removeClass('active');
        $('button[data-category="' + category + '"]').prop('disabled', true).addClass('active');

        // Other content elements like breadcrumbs, downloads, etc.
        $('.category-based').addClass('d-none');
        $(categoryClass).removeClass('d-none');
    }

    // Set application based content elements
    if (application && $(applicationClass).length) {
        $('.application-based').addClass('d-none');
        $(applicationClass).removeClass('d-none');
    }

    // Set category based applications
    $('.category-based-application').removeClass('application-inactive');
    $('.category-based-application').each(function() {
        if(!$(this).hasClass(category))
            $(this).addClass('application-inactive');
    });
};

// Set category / application of interest
$(function() {
    // Update interest cookie info when a user visits either an application or a category page
    if($('#category-of-interest').length == 1) {
        Cookies.set('proell_category_of_interest', $('#category-of-interest').data('category'), {expires: 365});
        Cookies.remove('proell_application_of_interest');
    }
    if($('#application-of-interest').length == 1)
        Cookies.set('proell_application_of_interest', $('#application-of-interest').data('application'), {expires: 365});

    // Render content elements based on current interest
    if($('.category-select').length && Cookies.get('proell_category_of_interest'))
        renderContentOfInterest();
});

//  Manually switch category of interest
$('.category-select').on('click', function () {
    Cookies.set('proell_category_of_interest', $(this).data('category'), {expires: 365});
    renderContentOfInterest();
});